import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {analyticsClient} from '../../../analytics-client';

import {OpenableModals} from '../../openable-modals';
import {openModal} from '../../openable-modals/openable-modals-actions';

import type {ThreadSidebarOpenSource} from './consts';

interface ThreadListSidebarParams {
    threadIds: string[];
    title: string;
    subtitle: string;
    source: ThreadSidebarOpenSource;
}

export function useOpenThreadListSidebar() {
    const dispatch = useDispatch();

    return useCallback(
        (params: ThreadListSidebarParams) => {
            analyticsClient.track(analyticsClient.EVENTS.TRACK_THREAD_SIDEBAR_OPENED_IN_CR, {
                source: params.source,
            });
            dispatch(openModal(OpenableModals.THREAD_LIST_SIDEBAR, params));
        },
        [dispatch]
    );
}
